import React from "react";
import Footer from "../Footer/Footer";
import MenuBar from "../MenuBar/MenuBar";
import "./Layout.css";

const Layout = ({ children }) => {
  return (
    <div className="layout-container">
      {/* El Menú siempre estará arriba de cualquier página */}
      <MenuBar /> 
      <main className="layout-main">
        {children} {/* Aquí es donde se inyectarán las páginas (Home, Shop, etc.) */}
      </main>

      <Footer />
    </div>
  );
};

export default Layout;